module.exports = __webpack_public_path__ + "img/scissor.58dff472.svg";